import { useCallback, useMemo } from 'react';
import OriginTracing from '@atlassiansox/origin-tracing';
import { useFlagsService } from '@atlassian/jira-flags';
import { defineMessages, useIntl } from '@atlassian/jira-intl';
import {
	fireTrackAnalytics,
	fireUIAnalytics,
	useAnalyticsEvents,
} from '@atlassian/jira-product-analytics-bridge';

export const messages = defineMessages({
	flagSuccessMessage: {
		id: 'share-button.ui.share-view.showFlag.copy-link-success-flag',
		defaultMessage: 'Link copied to clipboard',
		description:
			'Success message shown when a user clicks the copy link button and the link is copied to clipboard',
	},
});

export const useCopyLink = () => {
	const { showFlag } = useFlagsService();
	const { formatMessage } = useIntl();
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const originTracing = useMemo(
		() =>
			new OriginTracing({
				product: 'jira',
			}),
		[],
	);

	const handleCopyLink = useCallback(() => {
		const link = originTracing.addToUrl(globalThis.window.location.href);
		globalThis.navigator.clipboard.writeText(link);

		showFlag({
			type: 'success',
			title: formatMessage(messages.flagSuccessMessage),
			isAutoDismiss: true,
			messageId:
				'share-button.common.hooks.show-flag.success.ui.split-trigger-button.show-flag.success.share-view.show-flag.copy-link-success-flag.themed.1',
			messageType: 'transactional',
		});

		fireUIAnalytics(createAnalyticsEvent({}), 'button clicked', 'copyShareLink', {
			source: 'splitShareButton',
			originIdGenerated: originTracing.id,
		});

		fireTrackAnalytics(createAnalyticsEvent({}), 'page shared', 'copyLink', {
			source: 'splitShareButton',
			originIdGenerated: originTracing.id,
		});
	}, [formatMessage, originTracing, showFlag, createAnalyticsEvent]);

	return handleCopyLink;
};
